module.exports = __webpack_public_path__ + "img/LIVEPEN BOX 2.5f38cb95.png";